/**销售出入库路由 */
export default [
    {
        name:'bank',
        path:'bank',
        meta: { title: '销售出入库管理' },
        component: ()=>import('@/pages/bank/index.vue')
    }
]